import React, { useState, useEffect, forwardRef } from "react";
import { Input } from "@fragments";

const Description = forwardRef(function Description({ value, onInput }, ref) {
    const [_value, setValue] = useState(value);

    useEffect(() => {
        onInput(_value);
    }, [_value]);

    return (
        <Input.Text
            ref={ref}
            multiline={true}
            size={1000}
            value={_value}
            label="Descrição (opcional)"
            placeholder="Descrição (opcional)"
            onInput={setValue}
            emoji
            autoScroll
        />
    );
});

export default Description;
